import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { faPause, faPlay } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { PlayIndicatorBars } from '@components/main-components/cards/PlayIndicatorBars';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';
import { type TopPlaylistPostFragment } from '@graphql/reactQuery';
import { useHover } from '@hooks/useHover';
import { usePlaylistPlayingState } from '@hooks/usePlaylistPlayingState';

export const PlaylistPlayButton = ({
  playlist,
}: {
  playlist: TopPlaylistPostFragment['optionalShelf'];
}) => {
  const [hovering, hoverProps] = useHover();

  const { isPlaying, onPlayButtonClick } = usePlaylistPlayingState({
    playlistId: playlist?.id ?? '',
  });

  if (!playlist) return null;

  const buttonClass = clsx(hovering ? 'text-base800' : 'text-base600');

  const playButton = (
    <IconButton
      className="h-3 w-3 [&_svg]:h-3"
      icon={
        <FontAwesomeIcon
          className={clsx('text-base-s', buttonClass)}
          icon={isPlaying ? faPause : faPlay}
        />
      }
      animate
    />
  );

  return (
    <div
      className={clsx(
        'flex w-fit items-center gap-1.5 pb-1 text-base600 transition-colors hover:text-base800',
      )}
      onClick={onPlayButtonClick}
      {...hoverProps}
    >
      {playButton}
      {isPlaying && <PlayIndicatorBars smallBars />}
      <div className="line-clamp-1 w-fit text-base-s font-semibold">{playlist?.name}</div>
    </div>
  );
};
